import { useEffect, useState } from 'react';
import { loadData } from '../../services/codeDataStore';

const FIELD = 'Instructions';

const useInstructions = () => {
  const [instructions, setInstructions] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchInstructions = async () => {
      try {
        const data = await loadData('instructions', null);
        if (data?.[FIELD]) {
          setInstructions(data[FIELD]);
        } else {
          setInstructions(null);
        }
      } catch (err) {
        setError('Failed to fetch instructions');
      }
      setLoading(false);
    };
    fetchInstructions();
  }, []);

  return { instructions, loading, error };
};

export default useInstructions; 